// extracted by mini-css-extract-plugin
export default {"label":"PB1Db2aaGGytej5XAtIvL","boxWrapper":"_3eLH5P9HSlQzz1q1nYhGLC","buttonWrapper":"_26BpBdUSPr6-vTQO45OipB"};